import React, { PureComponent } from 'react';
import Dropdown from 'reactstrap/lib/Dropdown';
import PropTypes from 'prop-types';

class DropdownWithHover extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
  }

  static defaultProps = {
    className: ''
  };

  state = {
    isDropdownOpen: false,
  };

  onMouseEnter = () => {
    this.setState({ isDropdownOpen: true });
  }

  onMouseLeave = () => {
    this.setState({ isDropdownOpen: false });
  }

  toggle = () => {
    this.setState({ isDropdownOpen: false });
  }

  render() {
    const { isDropdownOpen } = this.state;
    const { children, className } = this.props;

    return (
      // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
      <Dropdown
        className={className}
        isOpen={isDropdownOpen}
        onMouseOver={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        toggle={this.toggle}
      >
        {children}
      </Dropdown>
    );
  }
}

export default DropdownWithHover;
